module.exports = __webpack_public_path__ + "img/ic_home_chat@2x.53e1749.png";